import { createEffect } from "effector";
import {
  restDetailsHandler,
  restGetUniqueHandler,
  restPostHandler,
} from "@utils/rest/RestClient";
import { EstimateResultsResponseDto } from "@type/estimateResults/estimateResults.response";
import {
  ResourceInputDto,
  SimulationSaveDto,
} from "@type/estimateInput/estimateInput.dto";
import { SimulationSaveResponse } from "@type/estimateInput/estimateInput.response";
import { SimulationLoadResponseDto } from "@state/em_simulation/dto/response/simulation.request.dto";

const simulationsComputeUrl = (window as any)?.api_url_compute
  ? (window as any)?.api_url_compute
  : "/ws/compute/";
const simulationsSaveUrl = (window as any)?.api_url_connect
  ? (window as any)?.api_url_connect
  : "/ws/connect/";
const simulationsLoadUrl = (window as any)?.api_url_load
  ? (window as any)?.api_url_load
  : "/ws/load/";
const farmerSimulationsComputeUrl = simulationsComputeUrl + "/FARMER";
const collectivitySimulationsComputeUrl =
  simulationsComputeUrl + "/COLLECTIVITY";
const farmerSimulationsSaveUrl = simulationsSaveUrl + "/FARMER";
const collectivitySimulationsSaveUrl = simulationsSaveUrl + "/COLLECTIVITY";
const farmerSimulationsLoadUrl = simulationsLoadUrl + "/FARMER/";
const collectivitySimulationsLoadUrl = simulationsLoadUrl + "/COLLECTIVITY/";

export const requestGetSimulationResults = createEffect({
  handler: restGetUniqueHandler<EstimateResultsResponseDto>(
    `${simulationsComputeUrl}`
  ),
});

export const requestFarmerComputeSimulation = createEffect({
  handler: restPostHandler<ResourceInputDto[], EstimateResultsResponseDto>(
    `${farmerSimulationsComputeUrl}`
  ),
});

export const requestCollectivityComputeSimulation = createEffect({
  handler: restPostHandler<ResourceInputDto[], EstimateResultsResponseDto>(
    `${collectivitySimulationsComputeUrl}`
  ),
});

export const requestFarmerSaveSimulation = createEffect({
  handler: restPostHandler<SimulationSaveDto, SimulationSaveResponse>(
    `${farmerSimulationsSaveUrl}`
  ),
});

export const requestCollectivitySaveSimulation = createEffect({
  handler: restPostHandler<SimulationSaveDto, SimulationSaveResponse>(
    `${collectivitySimulationsSaveUrl}`
  ),
});

export const requestLoadFarmerSimulation = createEffect({
  handler: restDetailsHandler<SimulationLoadResponseDto>(
    `${farmerSimulationsLoadUrl}`
  ),
});

export const requestLoadCollectivitySimulation = createEffect({
  handler: restDetailsHandler<SimulationLoadResponseDto>(
    `${collectivitySimulationsLoadUrl}`
  ),
});
